import { fetchFeatureDeliveryByTeam } from "../api/aiMetricsApi";
import { makeAdoMetricHook } from "./useAdoMetric";
import { ADO_QUERY_KEYS } from "./adoQueryKeys";

export const useAdoFeatureDeliveryByTeam = makeAdoMetricHook(
  ADO_QUERY_KEYS.featureDeliveryByTeam,
  fetchFeatureDeliveryByTeam,
);
